import Icon from '../components/Icon.vue'

Icon.register({"arrow-alt-circle-down":{"width":512,"height":512,"paths":[{"d":"M504 256C504 393 393 504 256 504S8 393 8 256 119 8 256 8 504 119 504 256zM212 140V256H141.1C130.4 256 125 269 132.6 276.5L247.5 390.8C252.2 395.5 259.7 395.5 264.4 390.8L379.3 276.5C386.9 268.9 381.5 256 370.8 256H300V140C300 133.4 294.6 128 288 128H224C217.4 128 212 133.4 212 140z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/arrow-alt-circle-down.js
// module id = null
// module chunks = 